module.exports = __webpack_public_path__ + "img/workspaceMenuIcon.830d2275.svg";